import { useQueryClient } from "@tanstack/react-query";
import appHomeEntryClient, { AppHomeEntry } from "../../../api/appHomeEntry";
import useKlydoMutation, {
  UseKlydoMutationOptions,
} from "../../../components/hooks/useKlydoMutation";

const useCreateAppHomeEntryMutation = (
  options?: UseKlydoMutationOptions<
    Partial<AppHomeEntry>,
    Partial<AppHomeEntry>,
    unknown
  >,
) => {
  const queryClient = useQueryClient();

  return useKlydoMutation({
    mutationKey: ["create-app-home-entry"],
    mutationFn: (entry: Partial<AppHomeEntry>) => {
      return appHomeEntryClient.createAppHomeEntry(entry);
    },
    onSuccess: (data, variables, context) => {
      queryClient.refetchQueries({
        queryKey: ["app-home-entries"],
      });
      options?.onSuccess?.(data, variables, context);
    },
  });
};
export default useCreateAppHomeEntryMutation;
